<div id="homeContainer">
  <router-outlet />
</div>
<app-home-footer />
